export enum LocalStorageAPP {
    x_token = 'x-token',
    authorization = 'Authorization',
    isLoggedin = 'isLoggedin',
    userData = 'userData',
    dataProgram = 'dataProgram',
    dataFlujoUser = 'flujoUser',
    dataUbigeo = 'ubigeo',
  }
  
  
  export enum GeneralConstants {
    returnUrl = 'returnUrl',
    allowedRoles = 'allowedRoles',
  }
  